import { msg } from "@lit/localize";
import { createAsyncAction, createAsyncActionGroup } from "@progressive-development/pd-spa-helper";
import type { appUser } from "@progressive-development/politik-model";

/** Load — kein Payload; das Backend ermittelt den User aus der Auth. */
export const loadProfile = createAsyncAction<appUser.UserProfile>("LOAD_PROFILE", {
  loadingTxt: msg("Profil wird geladen…", { id: "app.profile.loading.toast" }),
  smallBackground: true,
});

/** Update — mit Payload (UpdateUserProfile). Modal weil blockierende Aktion. */
export const updateProfile = createAsyncActionGroup<appUser.UpdateUserProfile, appUser.UserProfile>(
  "UPDATE_PROFILE",
  {
    loadingTxt: msg("Profil wird gespeichert…", { id: "app.profile.saving.toast" }),
    successTxt: msg("Profil aktualisiert.", { id: "app.profile.saved.toast" }),
    modal: true,
  },
);
